import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	logoAriaLabel: {
		id: 'generics.calmLogoAriaLabel2',
		defaultMessage: 'Calm Logo - Link to calm.com Homepage',
		description: 'A link that takes you to the homepage',
	},
	calmHealthForIndividuals: {
		id: 'nav.calmHealthForIndividuals',
		defaultMessage: 'For Individuals',
		description: 'Item in the Calm Health header dropdown that links to the Calm Health app for individuals',
	},
	calmHealthForOrganizations: {
		id: 'nav.calmHealthForOrganizations',
		defaultMessage: 'For Organizations',
		description:
			'Item in the Calm Health header dropdown that links to the Calm Health site for organizations',
	},
});
